export default __webpack_public_path__ + "static/media/clicker.35015ad2.svg";